import { Component, OnInit, inject } from '@angular/core';
import { Customer, CustomerModule, CustomerModuleKey } from '../../models/customer';
import { FormControl, FormGroup } from '@angular/forms';
import { getStorageObject, setStorageObject } from '../../utils/storage-manager';
import { CustomSnackbarService } from '../../services/custom-snackbar.service';
import { CustomerService } from '../../services/customer.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-welcome-video-management',
  templateUrl: './welcome-video-management.component.html',
  styleUrls: ['./welcome-video-management.component.scss']
})
export class WelcomeVideoManagementComponent implements OnInit {
  private customerService = inject(CustomerService);
  private translateService = inject(TranslateService);
  private snackbarService = inject(CustomSnackbarService);
  private router = inject(Router);

  form: FormGroup

  welcomeVideoConfig!: CustomerModule;

  customer?: Customer = getStorageObject('vertical');
  constructor() {
    this.form = new FormGroup({
      url: new FormControl(''),
      enabled: new FormControl(false)
    });
  }

  ngOnInit(): void {
    const defaultConfig: CustomerModule = { enabled: false, config: { url: '' } };
    let config: CustomerModule = defaultConfig;

    if(this.customer){
      console.log(this.customer, this.customer.modules.WELCOME_VIDEO);
    }

    // console.log(this.customer.modules);
    if(this.customer && CustomerModuleKey.WELCOME_VIDEO in this.customer.modules){
      config = this.customer.modules[CustomerModuleKey.WELCOME_VIDEO] || defaultConfig;
    }

    this.welcomeVideoConfig = config;

    this.form.patchValue({
      url: this.welcomeVideoConfig.config?.url,
      enabled: this.welcomeVideoConfig.enabled
    })
  }

  onSubmit(): void {
    const module: CustomerModule = {
      enabled: this.form.value.enabled,
      config: { url: this.form.value.url }
    };

    const data = {
      modules: {
        [CustomerModuleKey.WELCOME_VIDEO]: module
      }
    }

    this.customerService.updateModuleByKey(data, CustomerModuleKey.WELCOME_VIDEO).pipe(catchError((error) => {
      return this.snackbarService.showError(this.translateService.instant('global.saveChangeResponseError'));
    })
    ).subscribe(() => {
      if(!this.customer) {
        return;
      }
      this.customer.modules[CustomerModuleKey.WELCOME_VIDEO] = module;
      setStorageObject('vertical', this.customer);

      this.snackbarService.present(this.translateService.instant('global.saveChangeResponseSuccess'))
    })

    this.router.navigateByUrl('/dashboard');
  }
}
